import { render, staticRenderFns } from "./VerticalDottedTabs.vue?vue&type=template&id=da4c26c2&functional=true&"
import script from "./VerticalDottedTabs.vue?vue&type=script&lang=ts&"
export * from "./VerticalDottedTabs.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalDottedTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
